<template>
  <div class="house-body" :class="{'margin': alertShow}">
    <a-alert message="当前无权限，请开通权限后重新登录!" banner style="width: 100%" type="info" v-if="alertShow"/>
    <div class="house-wrap">
      <div class="house">
        <div class="floor"></div>
        <div class="wall">
          <div class="window"></div>
          <div class="door">
            <div class="door__square"></div>
            <div class="door__line"></div>
            <div class="door__square"></div>
          </div>
          <div class="window"></div>
        </div>
        <div class="top"></div>
        <div class="circle"></div>
        <div class="plastic">
          <div class="plastic__g">
            <div class="plastic__item" />
            <div class="plastic__item" />
            <div class="plastic__item" />
            <div class="plastic__item" />
            <div class="plastic__item" />
            <div class="plastic__item" />
            <div class="plastic__item" />
            <div class="plastic__item" />
          </div>
        </div>
        <div class="line">
          <div class="line__item" />
          <div class="line__item" />
          <div class="line__item" />
          <div class="line__item" />
          <div class="line__item" />
          <div class="line__item" />
          <div class="line__item" />
          <div class="line__item" />
          <div class="line__item" />
        </div>
      </div>
      <div class="clouds">
        <div class="cloud">
          <div class="cloud__item"></div>
          <div class="cloud__item"></div>
        </div>
        <div class="cloud">
          <div class="cloud__item" />
          <div class="cloud__item" />
        </div>
        <div class="cloud">
          <div class="cloud__item" />
          <div class="cloud__item" />
        </div>
        <div class="bird" />
      </div>
      <div class="birds">
        <div class="bird" />
        <div class="bird" />
      </div>
      <div class="tree">
        <div class="tree__item" />
        <div class="tree__item" />
        <div class="tree__item" />
      </div>
      <div class="bush">
        <div class="bush__item" />
        <div class="bush__item" />
      </div>
      <div class="dot" />
    </div>
  </div>
</template>
<script>
import { defineComponent, computed, watch, ref } from "vue";
import { useStore } from "vuex";
export default defineComponent({
  name: "House",
  props: {
    alertShow: Boolean
  },
  setup() {
    const store = useStore();
    let gameListRef = computed(() => store.state.settings.asscessGamesList);
    let alertShow = ref(false)
    watch([gameListRef],([gameList],[preGameList]) => {
      if (gameList.length < 1) {
        alertShow.value = true
      } else {
         alertShow.value = false
      }
    })
    return {
      alertShow
    };
  }
});
</script>
<style lang="less" scoped>
@import "./index.less";
.house-body {
  #flex-box.column-c-c();
  width: 100%;
}
.margin {
  margin-top: 30px;
}
</style>
